import { SimpleAlert, Spinner } from '@cimplico/components';
import { useEntity } from '../queries/use-entity';
import { Link, useParams } from 'react-router-dom';
import { useFirmContext } from '../providers/FirmProvider';
import { ArrowSmallLeftIcon } from '@heroicons/react/20/solid';
import { useState } from 'react';
import ErrorSplashScreen from './ErrorSplashScreen';
import NewPageContainer from '../components/page-container/NewPageContainer';
import EntityDetailsPanel from '../features/entity-overview/EntityDetailsPanel';
import EntityContentContainer from '../features/entity-overview/entity-content/EntityContentContainer';
import XeroErrorAlert from '../components/XeroErrorAlert';

function EntityOverviewPage(): JSX.Element {
    const { id } = useParams();
    const { shortId } = useFirmContext();

    const [xeroError, setXeroError] = useState<{ name: string; message: string } | undefined>();

    const entityQuery = useEntity(id);

    if (entityQuery.isLoading) {
        return (
            <div className="absolute w-full h-[calc(100vh-56px)]">
                <div className="absolute top-1/3 left-1/2">
                    <Spinner />
                </div>
            </div>
        );
    }

    if (entityQuery.isError || !entityQuery.isSuccess) {
        if (entityQuery.error?.response?.status === 404) {
            return (
                <ErrorSplashScreen
                    errorCode={404}
                    title="Entity not found."
                    redirectTitle="Back to entities"
                    redirectUrl={`/${shortId}/entities`}
                    leftArrow={true}
                />
            );
        }
        return (
            <ErrorSplashScreen
                title="An error has occurred."
                redirectTitle="Back to entities"
                redirectUrl={`/${shortId}/entities`}
                leftArrow={true}
            />
        );
    }

    const { entity } = entityQuery.data;

    return (
        <NewPageContainer>
            {xeroError && (
                <div className="w-fit mx-auto mb-8">
                    <XeroErrorAlert message={xeroError.message} errorName={xeroError.name} entityId={entity.id} entityName={entity.name} />
                </div>
            )}
            <div className="grid gap-y-4 mx-8 xl:mx-auto max-w-[1240px]">
                {entity.isArchived && (
                    <div className="mb-4">
                        <SimpleAlert title={`This entity is archived and is read-only mode.`} type="info" />
                    </div>
                )}
                <Link className="flex gap-2 items-center text-gray-500 text-sm cursor-pointer w-fit" to={`/${shortId}/entities`}>
                    <ArrowSmallLeftIcon className="w-5 h-5" />
                    <p>Back to Entities</p>
                </Link>
                <EntityDetailsPanel entity={entity} />
                <EntityContentContainer entity={entity} onXeroError={setXeroError} />
            </div>
        </NewPageContainer>
    );
}
export default EntityOverviewPage;
